import React from 'react'
import Select from 'react-select'

const MultiSelect = ({value, options, onChange}) => {
  return (
    <Select
      multi
      name='value'
      value={value}
      options={options}
      onChange={values => onChange(values)}
    />
  )
}

export default MultiSelect
